function normalizeOrderValue(value, fallback) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  if (parsed < 1) return 1;
  return Math.floor(parsed);
}

export function normalizeRows(rows) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const ordered = [...safeRows].sort((a, b) => {
    const orderA = normalizeOrderValue(a.order, Number.MAX_SAFE_INTEGER);
    const orderB = normalizeOrderValue(b.order, Number.MAX_SAFE_INTEGER);
    if (orderA !== orderB) return orderA - orderB;
    return String(a.teamName || "").localeCompare(String(b.teamName || ""), "es");
  });

  return ordered.map((row, index) => ({
    ...row,
    order: index + 1,
  }));
}

export function mapGroupToRows(group) {
  const source = Array.isArray(group?.tournamentGroupTeams) ? group.tournamentGroupTeams : [];
  const rows = source.map((teamRow, index) => ({
    groupTeamId: teamRow.id,
    teamId: teamRow.teamId,
    teamName: teamRow.team?.name ?? "Equipo",
    points: teamRow.points ?? 0,
    goalsFor: teamRow.goals ?? 0,
    goalsAgainst: teamRow.goalsReceived ?? 0,
    played: teamRow.matchsPlayed ?? 0,
    order: normalizeOrderValue(teamRow.order, index + 1),
  }));

  return normalizeRows(rows);
}

export function applyOrderInput(rows, groupTeamId, desiredOrder) {
  const source = Array.isArray(rows) ? rows : [];
  const total = source.length;
  if (!total) return [];

  const boundedOrder = Math.min(
    Math.max(normalizeOrderValue(desiredOrder, 1), 1),
    total
  );

  return normalizeRows(
    source.map((row) =>
      row.groupTeamId === groupTeamId ? { ...row, order: boundedOrder } : row
    )
  );
}

export function moveRow(rows, groupTeamId, direction) {
  const source = normalizeRows(rows);
  const index = source.findIndex((row) => row.groupTeamId === groupTeamId);
  if (index < 0) return source;

  const target = direction === "up" ? index - 1 : index + 1;
  if (target < 0 || target >= source.length) return source;

  const next = [...source];
  [next[index], next[target]] = [next[target], next[index]];
  return next.map((row, idx) => ({ ...row, order: idx + 1 }));
}

